import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Message from 'containers/Message';
import styles from 'css/main';
import 'intl';
const cx = classNames.bind(styles);
/*
 * React-router's <Router> component renders <Route>'s
 * and replaces `this.props.children` with the proper React Component.
 *
 * Please refer to `routes.jsx` for the route config.
 *
 * A better explanation of react-router is available here:
 * https://github.com/rackt/react-router/blob/latest/docs/Introduction.md
 */
const App = ({ children, router}) => {
  let currentRoute = router.getCurrentLocation().pathname;
  //let isPreview = currentRoute.indexOf('/launch') === 0;
  return (

    <div style={{minHeight:'100vh', marginTop:'80px'}} className="app-container">
      <Message />
      {children}
    </div>
  );
};

App.propTypes = {
  children: PropTypes.object
};



export default App;



// WEBPACK FOOTER //
// app/containers/App.jsx